<template lang="pug">
PrSelect.pr-select.bordered(v-nv v-bind="$props" @nv-enter="choose")
  .label.text-muted.font-weight-bold.small(v-show="label") {{ label }}
  .input {{ this._value || $t('Select') }}
  icon.icon.text-muted.ml-2(:icon="'fas caret-down'") 
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  label: String,
  value: String,
  options: Array,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean,
  floated: Boolean
}
const PrSelect = styled("div", Props)`
  display: flex;
  align-items: center;
  position: relative;

  .icon {
    flex-grow: 0;
    ${props => (props.label && props.floated && props.value ? "margin-top:24px;" : "")};
  }
  .label {
    max-width: 40%;
    min-width: 40%;
    overflow: hidden;
    margin-right: 15px;
    white-space: nowrap;
    ${props => (props.label && props.floated && props.value ? "position:absolute; top:10px;" : "")};
  }
  .input {
    flex-grow: 1;
    ${props => (props.label && props.floated && props.value ? "margin-top:24px;" : "")};
  }

  background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
  color: ${props => props.theme.color.onSurface};
  ${props => "border: 1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}
  ${props =>
    props.xsmall
      ? "padding: 0.35em 1em; font-size: " + props.theme.font.xsmall + ";"
      : props.small
      ? "padding: 0.5em 1.25em; font-size: " + props.theme.font.small + ";"
      : "padding: 0.75em 1.5em; font-weight:300; font-size: " + props.theme.font.base + ";"}
`

export default {
  name: "pr-select",
  components: {
    PrSelect
  },
  props: {
    ...Props
  },
  computed: {
    _value() {
      const res = this.options.find(option => option.key === this.value)
      if (!res) return this.value
      return res.value
    },
    items() {
      return this.options.map(option => {
        if (typeof option === "object") return { key: option.key, value: option.value, selected: option.key === this.value }
        else return { key: option, value: option, selected: option === this.value }
      })
    }
  },
  methods: {
    async choose($event) {
      const pid = await this.$dropdown(this.items, $event.target, "input", 20)
      if (!pid) return false
      this.$emit("update:value", pid)
    }
  }
}
</script>
